<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar ref="topBar" v-if="!granCliente">
      <span @click="visibleSidebar = !visibleSidebar">
        <i class="pi pi-bars" />
      </span>
    </AppTopBar>
    <AppTopBarGranCliente
      ref="topBar"
      @menu-toggle="onMenuToggle"
      v-if="granCliente"
    />
    <transition name="layout-sidebar" v-if="granCliente">
      <div
        :class="sidebarClass"
        @click="onSidebarClick"
        v-show="isSidebarVisible()"
      >
        <div class="layout-logo">
          <router-link to="/">
            <img alt="LogoIcired" src="@/assets/blue-logo.svg" />
          </router-link>
        </div>

        <AppProfile />
        <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
      </div>
    </transition>

    <Messages />
    <div
      v-bind:class="{
        'layout-main-gran-cliente': granCliente,
        'layout-main': !granCliente,
      }"
    >
      <Sidebar
        :showCloseIcon="false"
        :visible.sync="visibleSidebar"
        :baseZIndex="1000"
        v-if="!granCliente"
      >
        <ul class="sidebar">
          <li
            v-for="item in sidebarItems"
            :key="item.name"
            @click="navigateOrLogOut(item.route, item.internal, item.name)"
          >
            <span :class="getSelectedColorClass(item.route)">
              {{ item.name }}
            </span>
          </li>
        </ul>
      </Sidebar>
      <router-view :key="$route.fullPath" />
    </div>
    <AppFooter :granCliente="granCliente" />

    <AceptacionTos
      :displayConfirmation="displayConfirmation"
      v-on:close="closeTosAceptation()"
      :key="'Confirmacion' + displayConfirmation"
    />
    <Dialog header="¡Aviso!" :visible.sync="displayUpdateCarteras" :containerStyle="{width: '25vw'}" position="top" :modal="true">
      <p class="m-0 flex"><em class="pi pi-exclamation-triangle mr-2" style="font-size: 1.5rem; color: red" />Tienes carteras pendientes de actualizar.</p>
      <template #footer>
          <Button label="Actualizar" icon="pi pi-sign-in" @click="goToCarteras()" />
      </template>
  </Dialog>
  </div>
</template>

<script>
import AppTopBar from "./components/layout/AppTopbar.vue";
import Messages from "./components/layout/Messages.vue";
import AppFooter from "./components/layout/AppFooter.vue";
import AppMenu from "./components/layout/AppMenu.vue";
import AppTopBarGranCliente from "./components/layout/AppTopbarGranCliente.vue";
import AppProfile from "./components/layout/AppProfile.vue";
import AceptacionTos from "./components/portal-cliente/Utils/AceptacionTos.vue";
import AbilitiesMixin from "@/utils/ability";
import StringsMixin from "@/utils/strings";
import { GET_USUARIO_BY_UUID } from "@/graphQLQueries/UsuarioQueries";

export default {
  mixins: [StringsMixin, AbilitiesMixin],
  data() {
    return {
      granCliente: false,
      layoutMode: "static",
      layoutColorMode: "light",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      visibleSidebar: false,
      displayConfirmation: false,
      badgeValue: 0,
      carteras: [],
      displayUpdateCarteras: false,
      menu: [
        {
          id:1,
          label: this.$i18n.t("menu.operaciones").toUpperCase(),
          icon: "",
          items: [
            {
              label: this.$i18n.t("menu.nuevaOperacion"),
              icon: "",
              to: "/portal/expedientes/new",
            },
            {
              label: this.$i18n.t("menu.listaOperaciones"),
              icon: "",
              to: "/portal/expedientes/",
            },
          ],
        },
        {
          id:2,
          label: this.$i18n.t("menu.consultasTerceros").toUpperCase(),
          icon: "",
          items: [
            {
              label: this.$i18n.t("menu.nuevaConsulta"),
              icon: "",
              to: "/consultaFichero",
            },
            {
              label: this.$i18n.t("menu.listadoConsultas"),
              icon: "",
              to: "/portal/consultas",
            },
          ],
        },
        {
          id:3,
          label: this.$i18n.t("menu.configuracion").toUpperCase(),
          icon: "",
          items: [
            {
              label: this.$i18n.t("menu.cuentaYFacturacion"),
              icon: "",
              to: "/settings/accountAndBilling",
            },
            {
              label: this.$i18n.t("menu.myAccount"),
              icon: "",
              to: "/settings/profile",
            },
          ],
        },
        {
          id:4,
          label: this.$i18n.t("menu.gestionCarteras").toUpperCase(),
          icon: "",
          items: [
            {
              label: this.$i18n.t("menu.misCarteras"),
              icon: "",
              to: "/portal/misCarteras",
            },
          ],
        },
        {
          id:5,
          label: this.$i18n.t("menu.help").toUpperCase(),
          icon: "",
          items: [
            {
              label: this.$i18n.t("menu.preguntasFrecuentes"),
              icon: "",
              url: "https://ayuda.iciredimpagados.com/hc/es-es",
            },
            {
              label: this.$i18n.t("menu.contact"),
              icon: "",
              url: "https://ayuda.iciredimpagados.com/hc/es-es/requests/new",
            },
          ],
        },
      ],
      sidebarItems: [],
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
    carteras() {
      this.getBadges();
    }
  },
  created() {
    this.getUsuario();
    if (window.location.href.includes("localhost") ){
      document.title = "(Local) Portal Cliente";
    }else if (window.location.href.includes("dev.") ){
      document.title = "(Develop) Portal Cliente";
    }else if (window.location.href.includes("pre.") ){
      document.title = "(Pre) Portal Cliente";
    }else if (window.location.href.includes("demo.") ){
      document.title = "(Demo) Portal Cliente";
    }
  },
  mounted() {
    this.setSidebarItems();
    this.testTos();
  },
  methods: {
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          this.overlayMenuActive = !this.overlayMenuActive;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },

    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
        else return true;
      } else {
        return true;
      }
    },
    isGeneralSearchVisible() {
      return this.checkAbility("buscadorGeneral");
    },
    getSelectedColorClass(route) {
      return this.$refs.topBar.getSelectedColorClass(route);
    },
    setSidebarItems() {
      let sidebarItems = JSON.parse(
        JSON.stringify(this.$refs.topBar.menuItems)
      );
      this.sidebarItems = sidebarItems;

      this.replaceLastItemProperties("name");
      this.replaceLastItemProperties("route");
      this.replaceLastItemProperties("internal");
      this.sidebarItems.push(sidebarItems[sidebarItems.length - 1].childs[1]);
    },
    replaceLastItemProperties(propertyName) {
      this.sidebarItems[this.sidebarItems.length - 1][propertyName] =
        this.sidebarItems[this.sidebarItems.length - 1].childs[0][propertyName];
    },
    navigateOrLogOut(route, internal, name) {
      this.$refs.topBar.switchMiCuenta(name);
      this.$refs.topBar.navigate(route, internal);
      this.visibleSidebar = !this.visibleSidebar;
    },
    testTos() {
      if (
        !this.$store.state.profile.tos ||
        this.$store.state.profile.tos !== "1"
      ) {
        this.displayConfirmation = true;
      }
    },
    closeTosAceptation() {
      this.displayConfirmation = false;
    },
    getUsuario() {
      if (
        !this.$store.state.codigoPromotor &&
        this.$store.state.profile.uuid &&
        !this.$store.state.cartera
      ) {
        this.$apollo
          .query({
            query: GET_USUARIO_BY_UUID,
            variables: {
              uuidUsuario: this.$store.state.profile.uuid,
              idioma: this.$i18n.locale,
            },
          })
          .then((data) => {
            this.carteras = data.data.getUsuarioUuid.cartera.results
            this.$store.state.esMayorista =
              data.data.getUsuarioUuid.esMayorista;
            this.$store.state.clienteUuid =
              data.data.getUsuarioUuid.clienteUuid;
            this.$store.state.clienteIdLegal =
              data.data.getUsuarioUuid.clienteIdLegal;
            this.$store.state.idLegal = data.data.getUsuarioUuid.idLegal;
            this.$store.state.codigoPromotor =
              data.data.getUsuarioUuid.promotor.codigoPromotor;
            if (!this.$store.state.codigoPromotor) {
              this.$store.state.codigoPromotor = "";
            }

            this.granCliente = false;
            if (
              data.data.getUsuarioUuid.cartera &&
              data.data.getUsuarioUuid.cartera.totalElements > 0
            ) {
              window.location.href = process.env.VUE_APP_ICIRED_CS_URL;
              /*this.granCliente = true;
              this.$store.commit("setEsGranCliente", true);
              this.$store.commit(
                "addCarteraCliente",
                data.data.getUsuarioUuid.cartera
              );*/
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    getBadges() {
      this.carteras.forEach(cartera => {
        if(cartera.cartera.operativa && cartera.cartera.diasLimiteImpagos != null && cartera.cartera.diasLimiteIncidencias != null) {
          let days = cartera.cartera.diasLimiteImpagos <= cartera.cartera.diasLimiteIncidencias ? cartera.cartera.diasLimiteImpagos : cartera.cartera.diasLimiteIncidencias
          let date = new Date(new Date(cartera.cartera.fechaActualizacion).setDate(new Date(cartera.cartera.fechaActualizacion).getDate() + days))
          if(new Date().getTime() >= date.getTime())
            this.badgeValue += 1
        }
      });
      this.menu.forEach(menuitem => {
        if(menuitem.id == 4)
         menuitem.badge = this.badgeValue;
      });
      this.displayUpdateCarteras = this.badgeValue > 0 ? true : false
    },
    closeDialog() {
      this.displayUpdateCarteras = false
    },
    goToCarteras() {
      this.$router.push({ name: "misCarteras" });
      this.closeDialog();
    },
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
        },
      ];
    },
    sidebarClass() {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light",
        },
      ];
    },
    logo() {
      return this.layoutColorMode === "dark"
        ? "assets/layout/images/logo-white.png"
        : "assets/layout/images/logo.svg";
    },
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    AppTopBar: AppTopBar,
    AppMenu: AppMenu,
    AppTopBarGranCliente: AppTopBarGranCliente,
    AppProfile: AppProfile,
    AppFooter: AppFooter,
    Messages: Messages,
    AceptacionTos: AceptacionTos,
  },
};
</script>

<style lang="scss">
@import "./App.scss";
</style>

<style lang="scss" scoped>
.sidebar {
  li {
    cursor: pointer;

    span {
      border-bottom: 1px solid #e9e0ec;
      color: #666;
      display: block;
      font-weight: bold;
      padding: 1em;
      text-decoration: none !important;
      font-size: 125%;
    }
  }
  padding: 0.25em 1em;
  list-style-type: none !important;
}
</style>
